import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, Navigate } from "react-router-dom";
import { getAllOrphansBeneficiaryInfo } from "../../../apis/actions/recipient.actions";
import { showNotitfication } from "../../../components/utils/utils";
import Loader from "../../../biblio/Loader/Loader";
import { AppDispatch } from "../../../apis/store";

const UpdateRecipientGuard: React.FC = () => {
  const { access_token } = useParams();
  const dispatch = useDispatch<AppDispatch>();

  const [allowed, setAllowed] = useState<null | boolean>(null);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // Use unwrap() to get the actual response
        const response = await dispatch(
          getAllOrphansBeneficiaryInfo(access_token)
        ).unwrap();

        if (response?.status === 200) {
          setAllowed(true);
        } else {
          showNotitfication(
            "لم يتم العثور على الطلب , الرجاء التواصل مع الجمعية",
            "error"
          );
          setAllowed(false);
        }
      } catch (err) {
        showNotitfication(
          "لم يتم العثور على الطلب , الرجاء التواصل مع الجمعية",
          "error"
        );
        setAllowed(false);
      }
    };

    checkAccess();
  }, [dispatch, access_token]);

  if (allowed === null) {
    return <Loader />;
  }

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const UpdateRecipient = require("./UpdateRecipient").default;
  return <UpdateRecipient />;
};
export default UpdateRecipientGuard;
